import React, { useEffect, useState } from "react";

// Material UI
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Card, CardActionArea, CardContent, DialogContent, Typography } from "@mui/material";

// Components
import Modal from "../../../components/modal";
import Spinner from "../../../components/spinner";
import Dropdown from "../../../components/inputs/dropdown";
import Searchbox from "../../../components/inputs/searchbox";

// Hooks
import useUser from "../../../hooks/user/useUser";

// Service
import OrderService from '../../../services/orderService';

// Models and Utils
import { utils } from "../../../utils/utils";
import { channels, subChannels } from "../../../models/Channels";
import { OrderStates } from "../../../models/OrderEntity";

const InternalVoucherModal = ({ onClose, onCreate }) => {
  const [searchResult, setSearchResult] = useState();
  const [loading, setLoading] = useState(false);
  const [invoice, setInvoice] = useState();
  const [billingCode, setBillingCode] = useState();
  const [pvs, setPvs] = useState();

  const { branch, business } = useUser();

  useEffect(() => {
    const filterPvs = branch.pvs
      .filter(pv => pv.subChannel === subChannels.values.POS)

    if (filterPvs.length === 1) {
      setBillingCode(filterPvs[0].billingCode);
    }
    setPvs(filterPvs);
  }, [branch.pvs])

  const searchOrder = async () => {
    if (!invoice || !billingCode)
      return;

    setSearchResult(null)
    setLoading(true)
    const filters = {
      pageSize: 10,
      pageNumber: 1,
      channel: business.isFranchise ? channels.values.Franchises : channels.values.Tienda,
      subChannel: subChannels.values.POS,
      invoiceNumber: Number(invoice),
      billingCode: Number(billingCode),
      searchInternalVouchers: true,
      states: OrderStates.Invoiced

    }

    const orders = await OrderService
      .Search(filters)
      .then(res => res.values)
      .finally(() => setLoading(false));

      setSearchResult( orders.length > 0 ? orders : null);
  }

  const handleInvoiceNumber = (event) => {
    const value = (event.target.value >= 0) ? event.target.value : undefined;
    setInvoice(value);
  }
  const handleBillingCode = (event) => {
    const value = (event.target.value >= 0) ? event.target.value : undefined;
    setBillingCode(value);
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      searchOrder()
    }
  }
  return (
    <Modal
      open
      title='Nuevo comprobante interno'
      disableEnforceFocus
      disableAutoFocus
      disableEscapeKeyDown
      customButtons={() => (
        <DialogContent>
          <Button onClick={onClose} color="primary">
            Cancelar
          </Button>
        </DialogContent>
      )}
    >
      {
        loading &&
        <Grid container justifyContent='center'>
          <Spinner lockScreen />
        </Grid>
      }
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 5
          }}
        >
          <Dropdown
            fullWidth
            name='billingCode'
            onChange={handleBillingCode}
            size='small'
            label='PV'
            getOptionLabel={(option) => `(${option?.billingCode}) ${option?.name}`}
            getOptionValue={(option) => option?.billingCode}
            value={billingCode || ""}
            values={pvs}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 5
          }}
        >
          <Searchbox
            fullWidth
            size='small'
            name='invoiceNumber'
            label="Numero de Factura"
            onChange={handleInvoiceNumber}
            onKeyPress={handleKeyPress}
            value={invoice || ''}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 2
          }}
        >
          <Button onClick={searchOrder} color="primary">
            {" "}
            Buscar
          </Button>
        </Grid>

        {searchResult && searchResult.length > 0 ? (
          <Grid container spacing={2}>
            {searchResult.map((result) => (
              <Grid key={result.id} size={12}>
                <Card variant="outlined">
                  <CardActionArea disabled={false} onClick={() => { onCreate(result) }}>
                    <CardContent>
                      <Grid container spacing={1}>
                        <Grid size={12}>
                          <Typography>
                            <strong>Fecha creado: </strong>
                            {result.created ? utils.formatDate(result.vouchers[0].created) : ''}
                          </Typography>
                        </Grid>
                        <Grid size={12}>
                          <Typography>
                            <strong>Tipo de Factura: </strong>
                            {result.invoiceType}
                          </Typography>
                        </Grid>
                        <Grid size={12}>
                          <Typography>
                            <strong>Nro de Factura: </strong>
                            {`${result.billingCode}-${utils.formatVoucherNumber(result.vouchers[0].number)}`}
                          </Typography>
                        </Grid>
                        <Grid size={12}>
                          <Typography>
                            <strong>Importe Total: </strong>
                            {utils.formatMoney(result.amount)}
                          </Typography>
                        </Grid>
                        <Grid size={12}>
                          <Typography>
                            <strong>Cliente: </strong>
                            {result.customer.firstName} {result.customer.lastName}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : <Grid size={12}>
            <Typography color="primary" align="center">
              No se encontraron resultados
            </Typography>
          </Grid>
        }
      </Grid>
    </Modal>
  );
};

export default InternalVoucherModal;